import React, { useEffect, useState } from "react";
import { usePost } from 'seed/api';
import { Field } from "formik";
import $ from "jquery"
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import BaseField from "components/util/schema_form/fields/BaseField";
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import l from "components/util/l"


const SelectField = ({
	name,
	label,
	nodeId,
	options,
	collectionOptions,
	selectType = "dropdown",
	multiple = false,
	value,
	values,
	defaultValue,
	required,
	disabled,
	openText,
	placeholder = "Selecciona una opción%GA025",
	caption,
	helpMessage,
	enableComments,
	setFieldValue,
	onChange = () => { },
	onOpen = () => { },
}) => {
	const [callCollections, reqCollections] = usePost("/collections/get_select_options_data");

	// State for search input in dropdown (null means closed)
	const [selectSearch, setSelectSearch] = useState(null)
	const [manualOpen, setManualOpen] = useState(false);


	useEffect(() => {
		// Init default value if not defined
		if (value === undefined && defaultValue != null &&
			options.find((option) => option.value == defaultValue) != null)
			onChangeValue(defaultValue)
	}, [value, defaultValue, options])

	useEffect(() => {
		// Fetch collection data for dynamic options
		const queries = collectionOptions?.map((opt) => opt.query) ?? [];
		if (queries.length > 0) callCollections({ queries, node_id: nodeId });
	}, [collectionOptions, nodeId]);


	const getLabelName = (value) => {
		let opt = options.find((option) => option.value == value)
		return l(opt?.label ?? value);
	}

	const onChangeValue = (newValue) => {
		if (multiple) {
			// Handle multiple selection logic
			let selected = value || [];
			let pos = selected.indexOf(newValue);
			if (pos == -1) selected.push(newValue);
			else selected.splice(pos, 1);
			setFieldValue(name, selected);
			let labels = options.filter(item => selected.indexOf(item.value) != -1).map(item => item.label)
			onChange(selected, labels)
		}
		else {
			let label = options.find(item => item.value == newValue)?.label
			setFieldValue(name, newValue);
			onChange(newValue, label)
		}
	}

	if (reqCollections.loading) placeholder = l("Cargando...%GA028");
	// Parse collection data of multiple queries into options (value, label)
	const collectionData = (reqCollections?.data ?? [])
		.map(data => data.data).flat() // Flatten results of queries
		.filter(value => value != null)
		.map(value => ({ value: value.value, label: value.label }));
	options = options.concat(collectionData);


	return (
		<BaseField
			name={name}
			label={label}
			values={values}
			required={required}
			caption={caption}
			helpMessage={helpMessage}
			enableComments={enableComments}
			setFieldValue={setFieldValue}
		>
			{/* Hidden field to force form required validation */}
			<Field type={"text"} value={value || ""} className="hidden-field" required={required} />

			<div className="w-100">
				{/* Dropdown select type */}
				{selectType == "dropdown" && (
					<Autocomplete
						id={name}
						value={value}
						freeSolo={openText}
						required={required}
						disabled={disabled}
						multiple={multiple}
						forcePopupIcon
						style={{ width: "100%" }}
						options={
							// If there are more than 5 options and no open text, add search option
							(options.length > 5 && !openText ? [{ value: "#search#" }].concat(options) : options).map((item) => item.value)
						}
						filterOptions={(options, state) => {
							// If openText, use inputValue from state, else use selectSearch
							const searchTerm = openText ? (state.inputValue ?? "").trim() : (selectSearch ?? "").trim();
							if (searchTerm == "")
								return options
							return options.filter(option =>
								(getLabelName(option) ?? "").toLowerCase().includes(searchTerm.toLowerCase()) ||
								String(option ?? "").toLowerCase().includes(searchTerm.toLowerCase()) ||
								option == "#search#")
						}}
						open={
							// For non openText, control opening with manualOpen and selectSearch state, 
							// For openText let it open normally (undefined)
							!openText ? manualOpen || selectSearch != null : undefined
						}
						onOpen={(event, reason) => {
							onOpen();
							setManualOpen(true);
						}}
						onClose={(event, reason) => {
							setManualOpen(false);
							// Clear search and return focus to seed modal when closing by button or selecting an option
							if (reason == "toggleInput" || reason == "select-option") {
								setSelectSearch(null);
								$(".seed__modal [class^=\"Modal_container\"]").attr("tabindex", "-1");
							}
						}}
						getOptionLabel={(option) => getLabelName(option)}
						// Render selected tags
						renderTags={(value, getTagProps) =>
							value.map((option, index) => {
								const optionItem = options.find((item) => item.value == option)
								return (
									<Chip
										key={index}
										label={optionItem?.label ?? option}
										{...getTagProps({ index })}
										icon={optionItem?.icon ? <i className={optionItem?.icon + " px-1"}
											style={{ color: "#888" }}></i> : <span></span>}
									/>
								)
							})
						}
						// Render input field
						renderInput={(params) => {
							let selectedOption = options.find((option) => option.value == value)
							if (selectedOption != null && !multiple)
								params.inputProps.value = selectedOption?.label ?? selectedOption?.value
							else {
								if (openText) params.inputProps.value = value
								else params.inputProps.value = ""
							}

							return (<div className="w-100">
								<TextField {...params}
									type="text"
									className={(!openText ? "no-autocomplete " : " ") +
										(selectedOption && !multiple ? "hidden-input " : " ")}
									variant="outlined"
									placeholder={l(placeholder)}
									inputProps={{
										...params.inputProps,
										readOnly: !openText
									}}
								/>
								{(selectedOption && !multiple) ?
									<OptionItem
										label={getLabelName(selectedOption.value)}
										icon={selectedOption?.icon}
										disabled={disabled}
										isOnSelector={true}
										className={"d-flex align-items-center px-1 py-2 position-relative text-truncate mr-10"}
									/> : null}
							</div>
							)
						}}

						// Render each option
						renderOption={(option, { selected }) => {
							let optionItem = options.find((item) => item.value == option)

							// Render search input option
							if (option == "#search#")
								return (<div
									className="w-100 px-2 py-1"
									onClick={(e) => e.stopPropagation()}
								>
									<input type="text"
										style={{
											border: "1px solid #ccc",
											borderRadius: "0.25rem",
											fontSize: "0.9em",
											width: "100%", padding: "0.2rem 2rem 0.2rem 2rem"
										}}
										value={selectSearch}
										onChange={(e) => setSelectSearch(e.target.value)}
										onClick={(e) => {
											// Force focus and init search on first click
											if (selectSearch == null) setSelectSearch("");
											// Remove focus to seed modal to allow typing
											$(".seed__modal [class^=\"Modal_container\"]").removeAttr("tabindex");
											e.target.focus();
										}}
									/>
									<i className="fas fa-search mr-2" style={{ color: "#888", marginLeft: "-98%", fontSize: "0.9em" }}></i>

								</div>)

							// Render normal option
							return (
								<React.Fragment>
									{multiple && (
										<Checkbox
											icon={icon}
											color="primary"
											checkedIcon={checkedIcon}
											style={{ marginRight: 8 }}
											checked={selected}
										/>
									)}
									<OptionItem
										disabled={disabled}
										label={getLabelName(option)}
										icon={optionItem?.icon}
										caption={optionItem?.caption}
										className={"d-flex align-items-center px-1 py-2"}
									/>
								</React.Fragment>
							)
						}}
						onChange={(event, newValue) => onChangeValue(newValue)}
						onInputChange={(event, newValue) => { if (openText) onChangeValue(newValue) }}
					/>
				)}

				{/* List select type */}
				{selectType == "list" && (
					<div>
						{/* Multiple selection with checkboxes */}
						{multiple ? (
							<div>
								{options.map((option, idx) => {
									const randomStr = Math.random().toString(36).substring(2, 10);
									const autogeneratedId = `name-${option.value.replace(" ", "-")}-${randomStr}`;
									return (
										<div class="form-group mb-1" key={idx}>
											<div class="custom-control custom-checkbox">
												<input type="checkbox" id={autogeneratedId} class="custom-control-input" disabled={disabled}
													onChange={(event) => onChangeValue(event.target.value)} value={option.value} checked={value?.includes(option.value)}
												/>
												<label class="custom-control-label" for={autogeneratedId}>
													<OptionItem
														disabled={disabled}
														label={getLabelName(option.value)}
														icon={option?.icon}
														caption={option?.caption}
														className={"d-flex align-items-center px-1"}
													/>
												</label>
											</div>
										</div>
									)
								})}
							</div>
						) : (
							<div>
								{/* Single selection with radio buttons */}
								{options.map((option, idx) => {
									const randomStr = Math.random().toString(36).substring(2, 10);
									const autogeneratedId = `name-${option.value.replace(" ", "-")}-${randomStr}`;
									return (
										<div class="form-group mb-1" key={idx}>
											<div class="custom-control custom-radio">
												<input type="radio" id={autogeneratedId} class="custom-control-input" name={name}
													onChange={(event) => onChangeValue(event.target.value)} value={option.value} disabled={disabled} checked={value == option.value}
												/>
												<label class="custom-control-label" for={autogeneratedId}>
													<OptionItem
														disabled={disabled}
														label={getLabelName(option.value)}
														icon={option?.icon}
														caption={option?.caption}
														className={"d-flex align-items-center px-1"}
													/>
												</label>
											</div>
										</div>
									)
								})}
							</div>
						)}
					</div>
				)}

			</div>
		</BaseField>
	)
}

const icon = <i className="far fa-circle" />;
const checkedIcon = <i className="fas fa-circle-check" />;

const OptionItem = ({
	label,
	icon,
	caption,
	disabled,
	isOnSelector = false,
	className = ""
}) =>
	<div className={"option-item " + className}
		style={{
			pointerEvents: "none",
			color: "#777", fontSize: "1rem",
			...isOnSelector
				? {
					position: "absolute",
					marginTop: "-2.65rem",
					marginLeft: "1rem"
				}
				: {}
		}}>
		{icon ? <i className={icon + " mr-3"} style={{ color: "#888" }}></i> : null}
		<div>
			<span style={{ color: "#606a70", fontSize: "0.9em" }}>{label}</span>
			{caption ? <div className="text-truncate-2-lines" style={{ color: "#888", fontSize: "0.8em" }}>{caption}</div> : null}
		</div>
	</div>



export default SelectField;